export default "__VITE_ASSET__uTQuvMBT__"